/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
import React, { Fragment } from 'react';

import sortIcon from 'assets/images/sort-arrow.png';
import CurrencySign from 'components/price/CurrencySign.component';
import fixed from 'utils/values/fixed.util';
import parsfixed from 'utils/values/parsfixed.util';

class TableStocksUsedSold extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.getWindowScrollTop();
  }

  getWindowScrollTop = () => {
    if (window.pageYOffset) {
      return window.pageYOffset;
    } else if (document.documentElement) {
      return document.documentElement.scrollTop;
    }
    return 0;
  };

  searchFunc = (el) =>
    el
      .getName()
      .trim()
      .normalize('NFD')
      .replace(/^0+/, '')
      .replace(/’/, '')
      .replace(/'/, '')
      .toLocaleString('en-GB')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[\u00E9]/g, '')
      .search(this.props.search) !== -1 ||
    el
      .getBrand()
      .trim()
      .normalize('NFD')
      .replace(/^0+'/, '')
      .replace(/’/, '')
      .replace(/'/, '')
      .toLocaleString('en-GB')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u00E9]/g, '')
      .toLowerCase()
      .search(this.props.search) !== -1 ||
    el
      .getFamily()
      .trim()
      .normalize('NFD')
      .replace(/^0+/, '')
      .toLocaleString('en-GB')
      .replace(/’/, '')
      .replace(/'/, '')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u00E9]/g, '')
      .toLowerCase()
      .search(this.props.search) !== -1 ||
    el
      .getCategory()
      .trim()
      .normalize('NFD')
      .replace(/^0+/, '')
      .toLocaleString('en-GB')
      .replace(/’/, '')
      .replace(/'/, '')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u00E9]/g, '')
      .toLowerCase()
      .search(this.props.search) !== -1 ||
    (el.barcode ? el.barcode.toString() : '')
      .trim()
      .normalize('NFD')
      .replace(/^0+/, '')
      .replace(/’/, '')
      .replace(/'/, '')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u00E9]/g, '')
      .toLowerCase()
      .search(this.props.search) !== -1;

  render() {
    const categoryKeys = this.props.data.filter(this.searchFunc);
    return (
      <div>
        <div className="sort-nav">
          <table className="tbl-fixed-header tblUsedSold">
            <tbody>
              <tr>
                <td className="brand-name">
                  <span
                    role="button"
                    tabIndex={0}
                    onClick={() => {
                      this.props.onAddSort('brand');
                    }}
                  >
                    {' '}
                    <span>Brand</span>
                    <img src={sortIcon} alt="Sort by Brand" />
                  </span>
                </td>
                <td className="product-name">
                  <span
                    role="button"
                    tabIndex={0}
                    onClick={() => {
                      this.props.onAddSort('title');
                    }}
                  >
                    <span>Product name</span>
                    <img src={sortIcon} alt="Sort by product" />
                  </span>
                </td>
                <td style={{ width: '78px' }}>
                  <span
                    role="button"
                    tabIndex={0}
                    className="two-lines"
                    onClick={() => {
                      this.props.onAddSort('quantity');
                    }}
                  >
                    <span>Quantity in stock </span>
                    <img src={sortIcon} alt="Sort by quantity" />
                  </span>
                </td>
                <td style={{ width: '70px' }}>
                  <span
                    role="button"
                    tabIndex={0}
                    onClick={() => {
                      this.props.onAddSort('used');
                    }}
                  >
                    <span>Used</span>
                    <img src={sortIcon} alt="Sort by used" />
                  </span>
                </td>
                <td style={{ width: '60px' }}>
                  <span
                    role="button"
                    tabIndex={0}
                    onClick={() => {
                      this.props.onAddSort('sold');
                    }}
                  >
                    <span>Sold</span>
                    <img src={sortIcon} alt="Sort by sold" />
                  </span>
                </td>
                <td className="cost-price">
                  <span role="button" tabIndex={0}>
                    <span>Cost Price</span>
                  </span>
                </td>
                <td className="cost-used">
                  <span
                    role="button"
                    tabIndex={0}
                    className="two-lines"
                    onClick={() => {
                      this.props.onAddSort('costOfUsed');
                    }}
                  >
                    <span>Cost of used</span>
                    <img src={sortIcon} alt="Sort by cost used" />
                  </span>
                </td>
                <td className="cost-sold">
                  <span
                    role="button"
                    tabIndex={0}
                    className="two-lines"
                    onClick={() => {
                      this.props.onAddSort('costOfSold');
                    }}
                  >
                    <span>Cost of sold</span>
                    <img src={sortIcon} alt="Sort by cost sold" />
                  </span>
                </td>
                <td style={{ width: 'auto' }} />
              </tr>
            </tbody>
          </table>
        </div>
        <div className="tbl-container">
          <table id="btlSt" className="table-stocks tblUsedSold">
            <tbody>
              {categoryKeys.map((key) => {
                const stocks = key;
                return (
                  <Fragment key={stocks.id}>
                    <tr>
                      <td
                        role="button"
                        tabIndex={0}
                        className="brand-name"
                        onClick={() => {
                          this.props.OnClickRow(stocks);
                        }}
                      >
                        <span>{stocks.brand ? stocks.brand : 'Unknown'}</span>
                      </td>
                      <td
                        role="button"
                        tabIndex={0}
                        className="product-name"
                        onClick={() => {
                          this.props.OnClickRow(stocks);
                        }}
                      >
                        {stocks.title}
                      </td>
                      <td style={{ width: '58px', textAlign: 'center' }}>{fixed(stocks.units_in_stock)}</td>
                      <td style={{ width: '58px', textAlign: 'center' }}>
                        {stocks.usedSoldInRangeData ? fixed(stocks.usedSoldInRangeData.used) : 0}
                      </td>
                      <td style={{ width: '78px', textAlign: 'center' }}>
                        {stocks.usedSoldInRangeData ? stocks.usedSoldInRangeData.sold : 0}
                      </td>
                      <td className="cost-price-body-td">
                        {stocks.cost_price ? (
                          <>
                            <CurrencySign />
                            {stocks.cost_price}
                          </>
                        ) : (
                          ''
                        )}
                      </td>
                      <td className="cost-used-body-td">
                        {stocks.cost_price && stocks.usedSoldInRangeData && stocks.usedSoldInRangeData.used > 0 ? (
                          <>
                            <CurrencySign /> {stocks.usedSoldInRangeData.used * parsfixed(stocks.cost_price)}
                          </>
                        ) : (
                          '-'
                        )}
                      </td>
                      <td className="cost-sold-body-td">
                        {stocks.cost_price && stocks.usedSoldInRangeData && stocks.usedSoldInRangeData.sold > 0 ? (
                          <>
                            {' '}
                            <CurrencySign />
                            {stocks.usedSoldInRangeData.sold * parsfixed(stocks.cost_price)}
                          </>
                        ) : (
                          '-'
                        )}
                      </td>
                      <td style={{ width: 'auto' }} />
                    </tr>
                  </Fragment>
                );
              })}
              {categoryKeys.length === 0 && (
                <tr>
                  <td style={{ textAlign: 'center' }}>No products to show.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default TableStocksUsedSold;
